import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "disk",
  "use": "disk-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"disk\"><path d=\"M4 13.5h2V12H4zm12.44-3.91-1.82-6.37a2.38 2.38 0 0 0-2.27-1.72h-6.7c-1.05 0-1.98.71-2.27 1.72L1.56 9.59l-.06.2v3.58C1.5 14.82 2.68 16 4.13 16h9.74c1.45 0 2.63-1.18 2.63-2.63V9.79zM15 13.37c0 .62-.51 1.13-1.13 1.13H4.13c-.62 0-1.13-.51-1.13-1.13v-2.62h8.5c.83 0 1.5-.67 1.5-1.5H3.21l1.61-5.62c.11-.37.45-.63.83-.63h6.69c.39 0 .73.26.83.63L15 10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol